import { createContext, useContext } from 'react'
import type { ReactNode } from 'react'

import type { DevicesApi } from './devicesApi'

const DevicesApiContext = createContext<DevicesApi | null>(null)

export interface DevicesApiProviderProps {
  children: ReactNode
  api: DevicesApi
}

export const DevicesApiProvider = ({
  children,
  api,
}: DevicesApiProviderProps) => {
  return (
    <DevicesApiContext.Provider value={api}>
      {children}
    </DevicesApiContext.Provider>
  )
}

export const useDevicesApi = (): DevicesApi => {
  const api = useContext(DevicesApiContext)
  if (!api) {
    throw new Error(
      'useDevicesApi must be used within a <DevicesApiProvider>. ' +
        'Wrap your component tree with <DevicesApiProvider api={devicesApi}>.',
    )
  }
  return api
}
